module.exports = __webpack_public_path__ + "static/media/blackSkirt.a4f58e43.jpg";